import { cn } from "@dune/ui";
import OperationDescriptiveBlock from "./OperationDescriptiveBlock";
import RisquesAssociesBlock from "./RisquesAssociesBlock";

interface DetailsDescriptionContainerProps {
	showOperationDetails?: boolean;
	className?: string;
}

const DetailsDescriptionContainer = ({
	showOperationDetails = false,
	className,
}: DetailsDescriptionContainerProps) => {
	const containerClass = showOperationDetails
		? "flex flex-col gap-4 mb-6"
		: "flex flex-1 flex-col self-start gap-4 p-4 sticky top-10";

	return (
		<div className={cn(containerClass, className)}>
			<OperationDescriptiveBlock />
			<RisquesAssociesBlock />
		</div>
	);
};

export default DetailsDescriptionContainer;
